import { render, staticRenderFns } from "./shopowner.vue?vue&type=template&id=0fd490c2&scoped=true&"
import script from "./shopowner.vue?vue&type=script&lang=js&"
export * from "./shopowner.vue?vue&type=script&lang=js&"
import style0 from "./shopowner.vue?vue&type=style&index=0&id=0fd490c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd490c2",
  null
  
)

export default component.exports